<template>
  <Modal v-model="isShow" width="65%" :closable="false" :mask-closable="false">
    <div slot="header" class="info-header">
      <div class="ivu-modal-header-inner">交易定价表</div>
      <a class="ivu-modal-close" @click="closeModel"><i class="ivu-icon ivu-icon-ios-close"></i></a>
    </div>
    <div>
      <Form ref="tradepriceForm" :model="form" :label-width="80" :rules="ruleValidate">
        <Row>
          <Col span="12">
            <FormItem label="租户名称" prop="name">
              <Input v-model="form.name" :disabled="true"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="租户Code" prop="code">
              <Input v-model="form.tenantId" :disabled="true"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="微信" prop="name">
              <Input value="analyse_weixin" :disabled="true"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="价格(分)" prop="price">
              <Input v-model="form.weixinPrice" :disabled="disable"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="支付宝" prop="name">
              <Input value="analyse_zhifubao" :disabled="true"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="价格(分)" prop="price">
              <Input v-model="form.zhifubaoPrice" :disabled="disable"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="银行卡" prop="name">
              <Input value="analyse_card" :disabled="true"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="价格(分)" prop="price">
              <Input v-model="form.bankPrice" :disabled="disable"></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>
    <div slot="footer">
      <Button @click="closeModel">取消</Button>
      <Button type="primary" @click="submit" v-show="!disable">提交</Button>
    </div>
  </Modal>
</template>

<script>

export default {
  name: 'trade-price-batch-info',
  data () {
    return {
      form: { weixinPrice: 0, zhifubaoPrice: 0, bankPrice: 0 },
      isShow: false,
      type: 'add',
      disable: false,
      ruleValidate: {
        price: [
        ]
      }
    }
  },
  methods: {
    openModel (type, data) {
      this.isShow = true
      this.type = type
      if (data) {
        this.form.name = data.name
        this.form.tenantId = data.tenantId
      } else {
        this.form = {}
      }
      this.disable = type === 'detail'
    },
    closeModel () {
      this.isShow = false
    },
    submit () {
      let list = []
      list.push({ name: '微信解析', code: 'analyse_weixin', price: this.form.weixinPrice, tenantId: this.form.tenantId })
      list.push({ name: '支付宝解析', code: 'analyse_zhifubao', price: this.form.zhifubaoPrice, tenantId: this.form.tenantId })
      list.push({ name: '银行卡解析', code: 'analyse_card', price: this.form.bankPrice, tenantId: this.form.tenantId })
      this.$refs.tradepriceForm.validate((valid) => {
        if (valid) {
          this.P('tradeprice/batchCreate', list).then(data => {
            this.isShow = false
            this.$emit('handle-search')
          })
        } else {
          this.$Message.error('请检查填写的数据')
        }
      })
    }
  },
  mounted: function () {
  }
}
</script>
